export default __webpack_public_path__ + "static/media/ISMO CLASS-6 EXAM PATTERN 2026-27.a5af241e.pdf";